

import React, { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function SmartReportCreate({ 
    initialVisible: visible,
    onCloseInitial: onClose,
    userData,sourcechannel, 
    createdBy,
}) {
    const [fileData, setFileData] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const [fileName, setFileName] = useState("");
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [mobile, setMobile] = useState("");

    const fileInputRef = useRef(null);
    useEffect(() => {
    console.log("USER DATA IN MODAL 👉", userData);
}, [userData]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
    const localUser = JSON.parse(localStorage.getItem("loginObj"));

    const finalMobile =
        userData?.mobile ||
        localUser?.mobile ||
        localStorage.getItem("userMobile") ||
        "";

    setMobile(finalMobile);

    console.log("FINAL MOBILE 👉", finalMobile);
}, [userData]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.type !== "application/pdf") {
            toast.error("Only PDF files are allowed!");
            e.target.value = null;
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            toast.error("File size must not exceed 10 MB");
            e.target.value = null;
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            setFileData(result.split(",")[1]);
            setFilePreview(result);
            setFileName(file.name);
        };
        reader.readAsDataURL(file);
        e.target.value = null;
    };

    const handleDeleteFile = () => {
        setFileData(null);
        setFilePreview(null);
        setFileName("");
        if (fileInputRef.current) fileInputRef.current.value = null;
    };

    const handleSubmit = async () => {
        if (!fileData) {
            toast.error("Please choose a file first.");
            return;
        }

        const payload = {
            patient_id: userData?.code,
            base64_pdf: fileData,
            eclinic_code: "CENTRALECLINIC",
            createdby: createdBy || userData?.code,  // ✅ fallback to patientCode
    sourcechannel: sourcechannel || "B2C",
        };

        setLoading(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SMART_REPORT_BASEURL}post_smart_report`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );

            const msg = response.data?.message || JSON.stringify(response.data);
            handleDeleteFile();

            toast.success(msg, {
                onClose: () => onClose(),       // ← close dialog only AFTER toast disappears
                autoClose: 3000,
            });

        } catch (error) {
            console.error("Error posting report:", error);
            toast.error("Failed to upload report. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Backdrop
                sx={{ color: "#5579C6", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ToastContainer />

            <Dialog
                visible={visible}
                onHide={onClose}
                draggable={false}
                style={{ width: isMobile ? "90vw" : "60vw" }}
                header={
                    <div className="px-6 py-4">
                        <div className="flex justify-between items-center">
                            <h2 className="text-2xl text-primaryColor font-semibold text-gray-800 m-0">
                                Create Your Smart Health Report
                            </h2>
                        </div>
                        <p className="text-sm text-textGray mt-1 mb-0">
                            Upload Your Report to View Health Insights
                        </p>
                    </div>
                }
            >
                <div className="bg-White rounded-lg overflow-hidden">
                    {/* ——— BODY ——— */}
                    <div className="px-6 py-6 space-y-6">

                        {/* Name */}
                        <div>
                            <label className="block text-sm text-primaryColor font-medium text-gray-700 mb-1">
                                Name
                            </label>
                            <input
                                type="text"
                                placeholder="Enter name"
                                disabled
                                value={`${userData?.firstName || ""} ${userData?.lastName || ""}`}
                                className="w-full border-gray-300 border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
                            />
                        </div>

                        {/* Mobile */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1 text-primaryColor">
                                Mobile Number
                            </label>
                            <input
  type="tel"
  placeholder="Enter number"
  value={mobile}
  onChange={(e) => setMobile(e.target.value)}
  className="w-full border-gray-300 border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
/>
                        </div>

                        {/* Upload */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1 text-primaryColor">
                                Upload File
                            </label>
                            <div
                                onClick={() => fileInputRef.current.click()}
                                className="h-40 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50"
                            >
                                <CloudUploadIcon fontSize="large" className="text-green-400" />
                                <span className="mt-2 text-sm text-gray-500">Click here</span>
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="application/pdf"
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                            </div>

                            {fileName && (
                                <div className="mt-2 flex items-center space-x-2 px-1">
                                    <p className="text-sm text-gray-700 truncate">
                                        <strong>{fileName}</strong>
                                    </p>
                                    <button
                                        type="button"
                                        onClick={handleDeleteFile}
                                        className="p-1 rounded-full hover:bg-red-100"
                                    >
                                        <DeleteIcon fontSize="small" className="text-red-600" />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ——— FOOTER ——— */}
                    <div className="px-6 pb-6">
                        <button
  onClick={handleSubmit}
  className="w-full text-white rounded-lg py-3 transition"
  style={{ background: "var(--color-brand-primary)" }}
>
  Submit
</button>
                    </div>
                </div>
            </Dialog>
        </>
    );
}